import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from '../../../../../adapter-vue';
import {
  TUIStore,
  StoreName,
  IMessageModel,
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../../common/Icon.vue';
import TranslationContent from './translation-content.vue';
import checkIcon from '../../../../../assets/icon/check-sm.svg';
import { ITranslateInfo } from '../../../../../interface';

interface IProps {
  message: IMessageModel;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props as { message: IMessageModel }



const translationVisible = ref<boolean>(false);
const hasTranslationError = ref<boolean>(false);

const translationWrapperRef = ref<HTMLDivElement>();

let isSingleTranslation = true;

onMounted(() => {
  TUIStore.watch(StoreName.CHAT, {
    translateTextInfo: onMessageTranslationUpdated,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CHAT, {
    translateTextInfo: onMessageTranslationUpdated,
  });
});

function toggleErrorStatus(hasError: boolean) {
  hasTranslationError.value = hasError;
}

function onMessageTranslationUpdated(info: Map<string, ITranslateInfo[]>) {
  if (info === undefined) return;
  isSingleTranslation = false;
  const translationInfoList = info.get(props.message.conversationID) || [];
  for (let i = 0; i < translationInfoList.length; ++i) {
    const { messageID, visible } = translationInfoList[i];
    if (messageID === props.message.ID && visible !== undefined) {
      if (translationInfoList.length === 1 && visible) {
        isSingleTranslation = true;
      }
      hasTranslationError.value = false;
      translationVisible.value = visible;
      break;
    }
  }
}

return { __sfc: true,props, translationVisible, hasTranslationError, translationWrapperRef, isSingleTranslation, toggleErrorStatus, onMessageTranslationUpdated, TUITranslateService, Icon, TranslationContent, checkIcon }
}

})